module.exports = __webpack_public_path__ + "static/media/upgrademembership.2b44bed8.png";